{
  "nm": "29 - Error Cloud",
  "ddd": 0,
  "h": 500,
  "w": 500,
  "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" },
  "layers": [
    {
      "ty": 3,
      "nm": "29 - Error Cloud",
      "sr": 1,
      "st": 0,
      "op": 144,
      "ip": 0,
      "hd": true,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [310, 291, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 0, "ix": 11 }
      },
      "ef": [],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Line1 Outlines 2",
      "sr": 1,
      "st": 0,
      "op": 144,
      "ip": 10,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [37.418, 36.913, 0], "ix": 1 },
        "s": { "a": 0, "k": [90, 90, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [125.774, 79.574, 0], "ix": 2 },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0, "y": 1 },
              "s": [270],
              "t": 10
            },
            { "s": [-90], "t": 40 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-29.919, -29.413],
                    [29.919, 29.413]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "tm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0, "y": 1 },
                    "s": [0],
                    "t": 10
                  },
                  { "s": [100], "t": 25 }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": { "a": 0, "k": 0, "ix": 1 },
              "m": 1
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 1,
              "ml": 10,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 15, "ix": 5 },
              "c": { "a": 0, "k": [0, 0, 0], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [37.418, 36.913], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 2,
      "parent": 5
    },
    {
      "ty": 4,
      "nm": "Line1 Outlines",
      "sr": 1,
      "st": 0,
      "op": 144,
      "ip": 10,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [37.418, 36.913, 0], "ix": 1 },
        "s": { "a": 0, "k": [90, 90, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [125.774, 79.574, 0], "ix": 2 },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0, "y": 1 },
              "s": [270],
              "t": 10
            },
            { "s": [0], "t": 40 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-29.919, -29.413],
                    [29.919, 29.413]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "tm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0, "y": 1 },
                    "s": [0],
                    "t": 10
                  },
                  { "s": [100], "t": 25 }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": { "a": 0, "k": 0, "ix": 1 },
              "m": 1
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 1,
              "ml": 10,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 15, "ix": 5 },
              "c": { "a": 0, "k": [0, 0, 0], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [37.418, 36.913], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 3,
      "parent": 5
    },
    {
      "ty": 4,
      "nm": "Add_cloud 2 Outlines",
      "sr": 1,
      "st": 10,
      "op": 144,
      "ip": 10,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [126.5, 72.5, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0, 0, 100],
              "t": 10
            },
            { "s": [140, 140, 100], "t": 15 }
          ],
          "ix": 6,
          "x": "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [1.017, 19.096, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Overshoot",
          "ix": 1,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 5,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Bounce",
          "ix": 2,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 45,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Friction",
          "ix": 3,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 65,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 24.853],
                    [24.853, 0],
                    [3.509, -0.878],
                    [34.03, 0],
                    [7.516, -31.733],
                    [3.78, 0],
                    [0, -24.853],
                    [-24.853, 0]
                  ],
                  "o": [
                    [24.853, 0],
                    [0, -24.853],
                    [-3.78, 0],
                    [-7.516, -31.733],
                    [-34.031, 0],
                    [-3.508, -0.878],
                    [-24.853, 0],
                    [0, 24.853],
                    [0, 0]
                  ],
                  "v": [
                    [81, 72],
                    [126, 27],
                    [81, -18],
                    [70.043, -16.65],
                    [0, -72],
                    [-70.043, -16.65],
                    [-81, -18],
                    [-126, 27],
                    [-81, 72]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.2196, 0.2667], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [126.25, 72.25], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 4,
      "parent": 1
    },
    {
      "ty": 3,
      "nm": "Add_cloud 2",
      "sr": 1,
      "st": 10,
      "op": 144,
      "ip": 10,
      "hd": true,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [126.5, 72.5, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0, 0, 100],
              "t": 10
            },
            { "s": [140, 140, 100], "t": 15 }
          ],
          "ix": 6,
          "x": "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [1.017, 19.096, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Overshoot",
          "ix": 1,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 5,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Bounce",
          "ix": 2,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 45,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        },
        {
          "ty": 5,
          "mn": "ADBE Slider Control",
          "nm": "Scale - Friction",
          "ix": 3,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "mn": "ADBE Slider Control-0001",
              "nm": "Slider",
              "ix": 1,
              "v": {
                "a": 0,
                "k": 65,
                "ix": 1,
                "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
              }
            }
          ]
        }
      ],
      "ind": 5,
      "parent": 1
    }
  ],
  "v": "5.5.8",
  "fr": 48,
  "op": 144,
  "ip": 0,
  "assets": []
}
